// extracted by mini-css-extract-plugin
export default {"cabeca":"Entrega_cabeca__3W9xB","titulo":"Entrega_titulo__GaZD-","texto":"Entrega_texto__UFI6y","comBarra":"Entrega_comBarra__KG5KF","barraFixa":"Entrega_barraFixa__5YP00"};